<div class="frc-captcha" #widget></div>
